<template>
  <div class="loading_lod" :class="{ [curTheme]: true }" v-if="isActive">
    <!--<div
      class="lod_msg">
      <i class="el-icon-loading"></i> Пожалуйста, подождите...
    </div>-->
      <div class="lod_throbber"><div></div><div></div></div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      isActive: false,
    };
  },

  methods: {

    on() {
      this.isActive = true;
    },

    off() {
      this.isActive = false;
    },

  },

};
</script>

<style lang="scss">
@import "../styles/common/main";

.loading_lod {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999999;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .4);
  }
  .lod_msg {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -12px 0 0 -105px;
    i {
      margin-right: 5px;
    }
  }
  .lod_img {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200px;
    height: 200px;
    margin: -100px 0 0 -100px;
    background: 0 0 no-repeat url('/static/grx/loading.svg');
  }
}
@keyframes lod_throbber {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-webkit-keyframes lod_throbber {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes lod_throbber_reverse {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(-360deg);
    transform: rotate(-360deg);
  }
}
@-webkit-keyframes lod_throbber_reverse {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(-360deg);
    transform: rotate(-360deg);
  }
}
.lod_throbber {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -100px 0 0 -100px;
  width: 200px !important;
  height: 200px !important;
  div {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 80px;
    left: 80px;
    border-radius: 50%;
    border: 2px solid;
    border-color: #fff transparent #fff transparent;
    -webkit-animation: lod_throbber 2s linear infinite;
    animation: lod_throbber 2s linear infinite;
    &:nth-child(2) {
      width: 32px;
      height: 32px;
      top: 84px;
      left: 84px;
      border-color: transparent #fff transparent #fff;
      -webkit-animation: lod_throbber_reverse 2s linear infinite;
      animation: lod_throbber_reverse 2s linear infinite;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue